"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styles_1 = require("@material-ui/core/styles");
const ToggleButton_1 = __importDefault(require("@material-ui/lab/ToggleButton"));
const ToggleButtonGroup_1 = __importDefault(require("@material-ui/lab/ToggleButtonGroup"));
const classnames_1 = __importDefault(require("classnames"));
const find_1 = __importDefault(require("lodash/find"));
const isArray_1 = __importDefault(require("lodash/isArray"));
const prop_types_1 = __importDefault(require("prop-types"));
const totangoTheme_1 = require("../../theme/totangoTheme");
const tooltip_1 = __importDefault(require("../tooltip/tooltip"));
require("../../styles/components/switch-group.less");
const isSelected = (selected, { key }) => ((0, isArray_1.default)(selected) ? (0, find_1.default)(selected, { key }) : selected.key === key);
const SwitchGroup = ({ options, selected, size, disabledGroup, className, onChange }) => {
    const handleChange = (0, react_1.useCallback)((event, value) => {
        if (value === null) {
            return;
        }
        const selectedOption = options.find((o) => o.key === value);
        onChange(event, selectedOption);
    }, [options, onChange]);
    return (react_1.default.createElement(styles_1.MuiThemeProvider, { theme: totangoTheme_1.totangoTheme },
        react_1.default.createElement(ToggleButtonGroup_1.default, { value: selected.key, exclusive: true, onChange: disabledGroup ? undefined : handleChange, className: `switch-group blue ${className}`, size: size }, options.map((item) => (react_1.default.createElement(ToggleButton_1.default, { value: item.key, key: item.key, className: (0, classnames_1.default)('switch-button', { selected: isSelected(selected, item) }, { disabled: item.disabled || disabledGroup }, { small: size === 'small' }), disabled: item.disabled }, item.tooltip ? (react_1.default.createElement(tooltip_1.default, { enterDelay: item.tooltipDelayShow, leaveDelay: item.tooltipDelayHide, title: item.tooltip }, item.value)) : (item.value)))))));
};
SwitchGroup.defaultProps = {
    selected: [],
    size: 'medium',
    className: '',
};
const selectedPropType = prop_types_1.default.shape({
    key: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]).isRequired,
    value: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number, prop_types_1.default.element]).isRequired,
});
SwitchGroup.propTypes = {
    selected: prop_types_1.default.oneOfType([selectedPropType, prop_types_1.default.arrayOf(selectedPropType)]),
    options: prop_types_1.default.arrayOf(prop_types_1.default.shape({
        key: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]).isRequired,
        value: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number, prop_types_1.default.element]).isRequired,
        tooltip: prop_types_1.default.string,
        tooltipDelayShow: prop_types_1.default.number,
        tooltipDelayHide: prop_types_1.default.number,
        disabled: prop_types_1.default.bool,
    })).isRequired,
    onChange: prop_types_1.default.func.isRequired,
    size: prop_types_1.default.string,
    className: prop_types_1.default.string,
};
exports.default = SwitchGroup;
//# sourceMappingURL=switch-group.js.map